import { Typography } from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

const ParagraphContent = ({ header, subheader, content, isBlogContent }) => {
  const classes = useStyles()

  return (
    <div className={cx(classes.paragraph, {
      [classes.paragraphBlogContent]: isBlogContent,
    })}
    >
      {!!header && (
        <Typography
          variant="h5"
          component="h2"
          className={classes.header}
          color="primary"
        >
          {header}
        </Typography>
      )}
      {!!subheader && (
        <Typography
          variant="h6"
          component="h3"
          className={classes.subheader}
        >
          {subheader}
        </Typography>
      )}
      <Typography
        component="div"
        html={content}
        className={classes.paragraphContent}
      />
    </div>
  )
}

ParagraphContent.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isBlogContent: PropTypes.bool,
}

ParagraphContent.defaultProps = {
  isBlogContent: false,
}

export default ParagraphContent
